import { useQuery } from "@tanstack/react-query";
import { AI_INSIGHTS } from "@/data/mock";
import { withLatency } from "./simulate";

export async function fetchInsights() {
  return withLatency(AI_INSIGHTS);
}

export function useInsights() {
  return useQuery({ queryKey: ["insights"], queryFn: fetchInsights, staleTime: 60_000 });
}
